import { useNavigate } from 'react-router-dom';

function Footer({ simple = false }) {
  const navigate = useNavigate();

  const scrollTo = (id) => navigate('/', { state: { scrollTo: id } });

  if (simple) {
    return (
      <footer>
        <div className="footer-inner">
          <div className="footer-bottom">
            <div className="footer-copy">© 2025 FrontUp · DSGVO-konform · Server in Deutschland</div>
            <div className="footer-legal">
              <span onClick={() => navigate('/impressum')} style={{cursor:'pointer'}}>Impressum</span>
              <span onClick={() => navigate('/datenschutz')} style={{cursor:'pointer'}}>Datenschutz</span>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <div className="f-brand-logo">
              <div className="f-brand-icon">
                <img src="/logo-frontup.png" style={{width:32,height:32,objectFit:'cover',borderRadius:8,display:'block'}} alt="FrontUp" />
              </div>
              <span className="f-brand-name">FrontUp</span>
            </div>
            <div className="f-tagline">
              Dein KI-Mitarbeiter fürs Telefon.<br />
              Kein Anruf geht mehr verloren –<br />
              24/7, auf Deutsch, DSGVO-konform.
            </div>
          </div>
          <div>
            <div className="f-col-title">Produkt</div>
            <ul className="f-links">
              <li><button className="f-link-btn" onClick={() => scrollTo('anwendung')}>Features</button></li>
              <li><button className="f-link-btn" onClick={() => navigate('/preise')}>Preise</button></li>
              <li><button className="f-link-btn" onClick={() => scrollTo('demo')}>Demo</button></li>
            </ul>
          </div>
          <div>
            <div className="f-col-title">Branchen</div>
            <ul className="f-links">
              <li><button className="f-link-btn" onClick={() => navigate('/branche/gastro')}>Restaurant & Café</button></li>
              <li><button className="f-link-btn" onClick={() => navigate('/branche/arzt')}>Arztpraxis</button></li>
              <li><button className="f-link-btn" onClick={() => navigate('/branche/handwerk')}>Handwerk</button></li>
              <li><button className="f-link-btn" onClick={() => scrollTo('branchen')}>Alle Branchen →</button></li>
            </ul>
          </div>
          <div>
            <div className="f-col-title">Unternehmen</div>
            <ul className="f-links">
              <li><a href="https://frontup.eu" target="_blank" rel="noreferrer">frontup.eu</a></li>
              <li><button className="f-link-btn" onClick={() => navigate('/ueber-uns')}>Über uns</button></li>
              <li><span>Kontakt</span></li>
            </ul>
          </div>
          <div>
            <div className="f-col-title">Rechtliches</div>
            <ul className="f-links">
              <li><button className="f-link-btn" onClick={() => navigate('/impressum')}>Impressum</button></li>
              <li><button className="f-link-btn" onClick={() => navigate('/datenschutz')}>Datenschutz</button></li>
              <li><button className="f-link-btn" onClick={() => navigate('/agb')}>AGB</button></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copy">© 2025 FrontUp · DSGVO-konform · Server in Deutschland</div>
          <div className="footer-legal">
            <span onClick={() => navigate('/impressum')} style={{cursor:'pointer'}}>Impressum</span>
            <span onClick={() => navigate('/datenschutz')} style={{cursor:'pointer'}}>Datenschutz</span>
            <span onClick={() => navigate('/agb')} style={{cursor:'pointer'}}>AGB</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
